import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking" });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState({ status: "paid", data }); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState({ status: "failed" }); return; }
      } catch { /* keep trying */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setState({ status: "pending" });
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FBF9F5] flex flex-col items-center justify-center px-4 text-center">
      <img src="/masaya-logo.png" alt="Masaya" className="h-14 w-auto mb-8" />
      {state.status === "checking" && <><Loader2 className="animate-spin text-[#B87333]" size={40} /><p className="mt-4 text-[#635B52]" data-testid="pay-checking">Confirming your payment…</p></>}
      {state.status === "paid" && (
        <div data-testid="pay-success">
          <CheckCircle2 className="text-green-600 mx-auto" size={56} />
          <h1 className="mt-4 font-serif text-4xl text-[#2C2621]">Payment received</h1>
          <p className="mt-2 text-[#635B52]">Your {state.data?.kind === "deposit" ? "50% deposit" : "balance"} for {state.data?.booking_number} is paid. Thank you!</p>
          <Link to="/portal" className="mt-6 inline-block bg-[#B87333] text-white rounded-full px-7 py-3 font-medium">Go to my account</Link>
        </div>
      )}
      {(state.status === "pending") && <><Loader2 className="animate-spin text-[#B87333]" size={40} /><p className="mt-4 text-[#635B52]">Payment is processing. It may take a moment to reflect in your account.</p><Link to="/portal" className="mt-6 inline-block border border-[#B87333]/40 rounded-full px-6 py-3 font-medium text-[#2C2621]">My account</Link></>}
      {(state.status === "failed" || state.status === "error") && (
        <div><XCircle className="text-red-500 mx-auto" size={56} /><h1 className="mt-4 font-serif text-3xl text-[#2C2621]">Payment not completed</h1><Link to="/portal" className="mt-6 inline-block bg-[#B87333] text-white rounded-full px-7 py-3 font-medium">Back to my account</Link></div>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FBF9F5] flex flex-col items-center justify-center px-4 text-center">
      <img src="/masaya-logo.png" alt="Masaya" className="h-14 w-auto mb-8" />
      <XCircle className="text-[#B87333] mx-auto" size={52} />
      <h1 className="mt-4 font-serif text-3xl text-[#2C2621]">Payment cancelled</h1>
      <p className="mt-2 text-[#635B52]">No charge was made. You can pay anytime from your account.</p>
      <Link to="/portal" className="mt-6 inline-block bg-[#B87333] text-white rounded-full px-7 py-3 font-medium" data-testid="pay-cancel-portal">Go to my account</Link>
    </div>
  );
}
